import { render, staticRenderFns } from "./quality-cards.vue?vue&type=template&id=38a422cc"
import script from "./quality-cards.vue?vue&type=script&lang=js"
export * from "./quality-cards.vue?vue&type=script&lang=js"
import style0 from "./quality-cards.vue?vue&type=style&index=0&id=38a422cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports